import React from 'react'
import * as RT from '../../constants/Routing'
import defaultPhoto from '../../lib/images/default-back.jpg'
import ReactDOM from 'react-dom'
import Modal from '../App/Modal'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as Actions from '../../actions/Community'
import { withRouter } from 'react-router-dom'

class Component extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false
    }
  }

  openModal = () => {
    this.setState({
      openModal: true
    })
  }

  closeModal = () => {
    this.setState({
      openModal: false
    })
  }

  render = () => {
    const currentUser = this.props.currentUser
    const currentPath = this.props.currentPath
    const selectedCommunity = this.props.circle
    const preview = !!this.props.preview

    let name, photo, photoThumbStyle, price, published, description, memberLimit, memberCount, memberDisplay, host, id, nav, modal, joinBtn, joinedStatus = ''


    if (!!selectedCommunity) {


      id = selectedCommunity.id || ""
      name = selectedCommunity.name || ""
      photo = selectedCommunity.photo || defaultPhoto
      photoThumbStyle = {
        backgroundImage: `url(${photo})`,
      }

      if (preview) {
        price = (selectedCommunity.price >= 0) ? selectedCommunity.price : "<未入力(料金)>"
        memberLimit = (selectedCommunity.member_limit >= 0) ? selectedCommunity.member_limit : '<未入力(制限人数)>'
        nav = (
          <ul className='float-menu row'>
            <li className='col-6'><Link to={RT.COMMUNITY_PREVIEW_PATH.replace(/:id/, selectedCommunity.id)} className='active'>トップ</Link></li>
            <li className='col-6'><Link to={RT.COMMUNITY_PREVIEW_PATH.replace(/:id/, selectedCommunity.id)} className=''>投稿</Link></li>
          </ul>
        )

        joinBtn = (
          <span className='btn btn-submit'><i className="material-icons">add</i>参加する</span>
        )
      } else {
        price = (selectedCommunity.price >= 0) ? selectedCommunity.price : ""
        memberLimit = (selectedCommunity.member_limit >= 0) ? selectedCommunity.member_limit : ''
        nav = (
          <ul className='float-menu row'>
            <li className='col-6'><Link to={RT.COMMUNITY_PATH.replace(/:id/, selectedCommunity.id)} className={currentPath === RT.COMMUNITY_PATH.replace(/:id/, id) ? 'active' : ''}>トップ</Link></li>
            <li className='col-6'><Link to={RT.COMMUNITY_POSTS_PATH.replace(/:id/, selectedCommunity.id)} className={currentPath === RT.COMMUNITY_POSTS_PATH.replace(/:id/, selectedCommunity.id) ? 'active' : ''}>投稿</Link></li>
          </ul>
        )



        joinedStatus = selectedCommunity.joined_status

        switch (joinedStatus) {
          case 'applied':
            joinBtn = (
              <span className='btn btn-submit disabled'><i className="material-icons">add</i>参加申請済み</span>
            )
            break;
          case 'approved':
            joinBtn = (
              <span className='btn btn-submit disabled'>
                <i className="material-icons">add</i>参加中
              </span>
            )
            break
          case 'own':
            joinBtn = (
              <span className='btn btn-submit disabled'>
                my サークル
              </span>
            )
            break
          default:
            joinBtn = (
              <span className='btn btn-submit' onClick={this.openModal}><i className="material-icons">add</i>参加する</span>
            )
            break;
        }
      }



      if (this.props.manageMode) {
        nav = (
          <div className='border-bottom row'></div>
        )
        joinBtn = null
      }


      description = selectedCommunity.description || ""
      published = selectedCommunity.published
      memberCount = selectedCommunity.members.length

      if (memberLimit === 0) {
        memberDisplay = (
          <div className='circle-member-count'><i className="material-icons">people</i>{memberCount}/(無制限) 人</div>
        )
      } else {
        memberDisplay = (
          <div className='circle-member-count'><i className="material-icons">people</i>{memberCount}/{memberLimit}人</div>
        )
      }

      host = !!selectedCommunity.host ? selectedCommunity.host : currentUser

      if (!!currentUser) {
        // ログインしているとき

        if (!!this.props.CreditCard.usersCards && this.props.CreditCard.usersCards.length > 0 && !!this.props.CreditCard.usersCards.find((e) => { return e.is_active === true }) > 0 && (!!currentUser && currentUser.id !== selectedCommunity.host.id)) {

          const card = this.props.CreditCard.usersCards.find((e) => { return e.is_active === true })

          modal = (
            <Modal
              okClickHandler={() => {
                this.props.communityJoin(id, card.id)
                this.setState({openModal: false})
              }}
              headerTitle='サークルに参加'
              isOpen={this.state.openModal}
              closeModal={this.closeModal}
              okText='参加する'
            >
              {(() => {
                if (selectedCommunity.price > 0) {
                  return (
                    <div>
                      <p>月額{selectedCommunity.price}円は以下のカードから決済されます。</p>
                      <p className='card-info alert alert-info'>**** **** **** {card.last4} ({card.brand})</p>
                    </div>
                  )
                } else {
                  //TODO
                }
              })()}
              <p>本当に参加してよろしいですか？</p>
            </Modal>
          )
        } else {

          if ((!!currentUser && currentUser.id === selectedCommunity.host.id)) {
            modal = (
              <Modal
                okClickHandler={null}
                headerTitle='自分が作成したサークルです'
                isOpen={this.state.openModal}
                closeModal={this.closeModal}
                cancelText='戻る'
                okText='公開する'

              >
                <p>このサークルはあなたが作成したサークルです。</p>
                <p>自分が作成したサークルには参加できません。</p>
              </Modal>
            )
          } else {
            // console.log('カード', price)
            if (price > 0) {
              //カード情報ないとき
              modal = (
                <Modal
                  okClickHandler={null}
                  headerTitle='カード情報が必要です'
                  isOpen={this.state.openModal}
                  closeModal={this.closeModal}
                >
                  <p>サークルに加入するためには有効なクレジットカードを登録しておく必要があります。</p>
                  <Link to={RT.USER_CREDIT_EDIT_PATH} className='btn btn-primary btn-block mb10'>クレジットカードを登録する</Link>
                </Modal>
              )
            } else {
              modal = (
                <Modal
                  okClickHandler={() => {
                    this.props.communityJoin(id)
                    this.setState({ openModal: false })
                  }}
                  headerTitle='サークルに参加'
                  isOpen={this.state.openModal}
                  closeModal={this.closeModal}
                  okText='参加する'
                >
                  <p>本当に参加してよろしいですか？</p>
                </Modal>
              )
            }

          }
        }
      } else {
        // ログインしていないとき
        modal = (
          <Modal
            okClickHandler={null}
            headerTitle='ログイン or 登録してください'
            isOpen={this.state.openModal}
            closeModal={this.closeModal}
            cancelText='戻る'
          >
            <p>サークルに参加するには会員になる必要があります。</p>
            <Link to={RT.SIGN_IN_PATH} className='btn btn-primary btn-block mb10'>ログイン</Link>
            <Link to={RT.SIGN_UP_PATH} className='btn btn-secondary btn-block mb10'>会員登録</Link>
          </Modal>
        )
      }

    }

    


    return (
      <div className="circleHeader">
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
        <div className='circleThumb' style={photoThumbStyle}></div>
        <div className='circleHeader'>
          <div className='containter'>
            <div className='col-12'>
              <h1 className='circleName'>{name}</h1>
            </div>
            <div className='col-12 clearfix'>
              {joinBtn}
              <div className='float-left'>
                <div className='circle-price'><i className="material-icons">attach_money</i>{price}円/月</div>
                {memberDisplay}
              </div>
            </div>
            <div className='col-12'>
              {nav}
            </div>
          </div>
        </div>
      </div>

    )
  }

}

const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/Community/CommunityHead.jsx